var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaplock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 0C.56 0 0 .56 0 1.25v17.5C0 19.44.56 20 1.25 20h17.5c.69 0 1.25-.56 1.25-1.25V1.25C20 .56 19.44 0 18.75 0H1.25zm9.16 4.104a.625.625 0 00-.82 0L4.773 8.278a.625.625 0 00.41 1.097H6.25v3.75c0 .345.28.625.625.625h6.25c.345 0 .625-.28.625-.625v-3.75h1.069a.625.625 0 00.409-1.097l-4.819-4.174zM6.874 15a.625.625 0 100 1.25h6.25a.625.625 0 100-1.25h-6.25z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/caplock.a4ee2bd3.svg";
export { SvgCaplock as ReactComponent };